import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  fill: "none",
  viewBox: "0 0 10 11"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M4.143 1.424a1 1 0 0 1 1.714 0l.9 1.495a1 1 0 0 0 .63.458l1.7.394a1 1 0 0 1 .53 1.63L8.473 6.718a1 1 0 0 0-.24.742l.15 1.739a1 1 0 0 1-1.386 1.007l-1.607-.68a1 1 0 0 0-.78 0l-1.607.68a1 1 0 0 1-1.386-1.007l.15-1.739a1 1 0 0 0-.24-.742L.383 5.401a1 1 0 0 1 .53-1.63l1.7-.394a1 1 0 0 0 .63-.458z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }